module.exports = __webpack_public_path__ + "img/vk.6c40beaf.svg";